module.exports = __webpack_public_path__ + "img/61.8.TSS.67764b45.png";